import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'HexToHsl'
})
export class HexToHsl implements PipeTransform {
  transform(hex: string | null | undefined): string {
    if (!hex) {
      return 'transparent';
    }
    const hsl = this.hexToHsl(hex);
    return `hsl(${hsl.h}, 61%, 90%)`;
  }

  private hexToHsl(hex: string): { h: number, s: number, l: number } {
    hex = hex.replace(/^#/, '');
    if (hex.length === 3) {
      hex = hex.split('').map(x => x + x).join('');
    }
    const r = parseInt(hex.substring(0, 2), 16) / 255;
    const g = parseInt(hex.substring(2, 4), 16) / 255;
    const b = parseInt(hex.substring(4, 6), 16) / 255;

    const max = Math.max(r, g, b), min = Math.min(r, g, b);
    let h = 0, s = 0, l = (max + min) / 2;

    if (max !== min) {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r: h = (g - b) / d + (g < b ? 6 : 0); break;
        case g: h = (b - r) / d + 2; break;
        case b: h = (r - g) / d + 4; break;
      }
      h *= 60;
    }
    return { h: Math.round(h), s: Math.round(s * 100), l: Math.round(l * 100) };
  }
}
